import { type DealMetricType } from "@vega-api/generated/types/dealMetricType";
import { type CoreCurrency } from "@vega-core/models/money";

export const MODAL_OPTION_VALUES = {
  CUSTOM: "custom",
} as const;

// TODO: Remove these hard-coded checks and options once this tech debt is resolved: https://vegainvestments.atlassian.net/browse/VD-26368
export const ACS_TEAM_CONTACT_NAME = "ACS Team Contact";

export const ACS_TEAM_CONTACT_OPTIONS = [
  "Christine Wong",
  "Juliet O'Hare",
  "Chelsea Strickland",
  "Michael Munson",
  "Ben Rosenberg",
  "Eugene Say",
  "Chris Jahrmarkt",
].map((name) => ({ label: name, value: name }));

export const FORM_FIELD_NAMES = {
  SELECTED_OPTION: "selectedOption",
  CUSTOM_LABEL: "customLabel",
  CUSTOM_VALUE: "customValue",
  METRIC_TYPE: "metricType",
} as const;

export const MODAL_TYPES = {
  METRIC: "metric",
  SECTION: "section",
} as const;

export type ModalOptionValue =
  (typeof MODAL_OPTION_VALUES)[keyof typeof MODAL_OPTION_VALUES];
export type FormFieldName =
  (typeof FORM_FIELD_NAMES)[keyof typeof FORM_FIELD_NAMES];
export type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];

export type ModalFormValues = {
  [FORM_FIELD_NAMES.SELECTED_OPTION]: string;
  [FORM_FIELD_NAMES.CUSTOM_LABEL]: string;
  [FORM_FIELD_NAMES.CUSTOM_VALUE]:
    | string
    | { amount: string; currency: CoreCurrency };
  [FORM_FIELD_NAMES.METRIC_TYPE]: DealMetricType | undefined;
};
